import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-discovercard",
  templateUrl: "./discovercard.component.html",
  styleUrls: ["./discovercard.component.scss"],
})
export class DiscovercardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
